export enum TimeToPayDialogActionVariant {
  Button = 'BUTTON',
  Text = 'TEXT',
}
